import "@zenlayer/zen-design/esm/tooltip/style";
import _Tooltip from "@zenlayer/zen-design/esm/tooltip";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "@zenlayer/zen-design/esm/checkbox/style";
import _Checkbox from "@zenlayer/zen-design/esm/checkbox";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["clauses", "text", "showTooltip", "locale", "historyHasAgreed", "scrollIntoView", "className", "style"];
import { pickDomAttrs } from '@zenlayer/zen-design/esm/_util/utils';
import t from '@zenlayer/zen-intl18';
import { useControllableValue, useInViewport, useUpdateEffect } from 'ahooks';
import classnames from 'classnames';
import React, { useEffect } from 'react';
import { getAgreementText } from "../../function/getAgreementText";
import "./index.less";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * 协议条款确认组件
 * @component
 * @param {AgreementProps} props - 组件的属性
 * @param {React.ReactNode} props.text - 自定义协议文本。如果提供了这个属性，会覆盖 clauses 生成的文本
 * @param {{ name: string; url: string }[]} props.clauses - 包含协议条款的数组，每个条款有 name 和 url 属性
 * @param {boolean} props.showTooltip - 是否显示提示信息
 * @param {boolean} props.defaultChecked - 复选框的默认状态
 * @param {boolean} props.checked - 复选框状态
 * @param {Locales} props.locale - 国际化文本语言标识 zh | en
 * @param {boolean} props.historyHasAgreed - 是否同意过协议条款
 * @param {boolean} props.scrollIntoView - 显示提示信息并且复选框未选中，组件是否自动滚动到视图内 默认为false
 * @param {string} props.className - 自定义类名
 * @param {React.CSSProperties} props.style - 自定义内联样式
 * @return {JSX.Element}
 * @example
 * <Agreement
 *   text={
 *       <span>example</span>
 *      }
 *   historyHasAgreed={true}
 *   showTooltip={true}
 *   checked={true}
 *   scrollIntoView={true}
 *   onChange={(val) => {
 *           console.log(val)
 *   }}
 * />
 */
var Agreement = function Agreement(props) {
  var clauses = props.clauses,
      text = props.text,
      _props$showTooltip = props.showTooltip,
      showTooltip = _props$showTooltip === void 0 ? false : _props$showTooltip,
      locale = props.locale,
      historyHasAgreed = props.historyHasAgreed,
      _props$scrollIntoView = props.scrollIntoView,
      scrollIntoView = _props$scrollIntoView === void 0 ? false : _props$scrollIntoView,
      className = props.className,
      style = props.style,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useControllableValue = useControllableValue(props, {
    defaultValue: false,
    defaultValuePropName: 'defaultChecked',
    valuePropName: 'checked',
    trigger: 'onChange'
  }),
      _useControllableValue2 = _slicedToArray(_useControllableValue, 2),
      checked = _useControllableValue2[0],
      onChange = _useControllableValue2[1];

  var divRef = React.useRef(null);
  var textNode = text || (clauses ? getAgreementText(clauses, locale, historyHasAgreed) : undefined);
  useUpdateEffect(function () {
    if (scrollIntoView) {
      if (showTooltip && !checked) {
        var _divRef$current;

        (_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, [showTooltip, checked]);

  var _useInViewport = useInViewport(divRef),
      _useInViewport2 = _slicedToArray(_useInViewport, 1),
      inViewport = _useInViewport2[0];

  useEffect(function () {
    if (historyHasAgreed) {
      onChange(true);
    }
  }, [historyHasAgreed]);
  return /*#__PURE__*/_jsxs("div", {
    ref: divRef,
    className: classnames('agreement-wrap', className, {
      noView: !inViewport
    }),
    style: style,
    children: [!historyHasAgreed && /*#__PURE__*/_jsx(_Tooltip, {
      placement: "topLeft",
      open: showTooltip && !checked,
      title: t('29jSP-omuTx_'),
      getPopupContainer: function getPopupContainer(triggerNode) {
        return triggerNode;
      },
      arrow: {
        pointAtCenter: true
      },
      animate: "wobble",
      children: /*#__PURE__*/_jsx(_Checkbox, _objectSpread(_objectSpread({}, pickDomAttrs(restProps).data), {}, {
        size: "s",
        shape: "circular",
        checked: checked,
        onChange: onChange,
        style: {
          display: 'flex',
          marginTop: 2
        }
      }))
    }), textNode]
  });
};

Agreement.scrollIntoView = function () {
  var agreementDom = document.querySelector('.agreement-wrap.noView');
  agreementDom === null || agreementDom === void 0 ? void 0 : agreementDom.scrollIntoView({
    behavior: 'smooth'
  });
};

export default Agreement; // interface AgreementHOCProps {
//   children: React.ReactElement<{ onClick: () => void }>;
//   defaultChecked?: boolean;
//   checked?: boolean;
//   onChange?: (checked: boolean) => void;
// }
// const AgreementHOC: React.FC<AgreementHOCProps> = (props) => {
//   const { children } = props;
//   const [checked, onChange] = useControllableValue<boolean>(props, {
//     defaultValue: false,
//     defaultValuePropName: 'defaultChecked',
//     valuePropName: 'checked',
//     trigger: 'onChange',
//   });
//   return React.isValidElement(children)
//     ? React.cloneElement(children, { onClick: () => {} })
//     : null;
// };